/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2FilterAsc/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2FilterAsc({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2FilterAsc",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2FilterAsc.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-1uYQs0': alignSelf,'--mt-2-1uYQs0': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1uYQs0': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1uYQs0': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1uYQs0': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1uYQs0': opacity,'--w-10-1uYQs0': typeof width === 'number' ? `${width}px` : width,'--h-11-1uYQs0': typeof height === 'number' ? `${height}px` : height,'--f-12-1uYQs0': fill,'--a-7-1uYQs0': isAnimated ? animation : "none",'--sd-8-1uYQs0': isAnimated ? strokeDashoffset : 0,'--sd-9-1uYQs0': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2FilterAsc.SvgPath"
  data-view-path={viewPath}
 d="M7.25 12.5a.75.75 0 010 1.5h-2a.75.75 0 010-1.5h2zM10.22.22a.75.75 0 011.06 0l2.5 2.5A.75.75 0 0113.25 4h-1.5v9a1 1 0 11-2 0V4h-1.5a.75.75 0 01-.53-1.28l2.5-2.5zM7.25 9.5a.75.75 0 010 1.5h-4a.75.75 0 010-1.5h4zm0-3a.75.75 0 010 1.5H.75a.75.75 0 010-1.5h6.5z"
 style={{'--f-12-1uYQs0': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}